import { type InventorySlot, MAX_STACK } from "@ghostland/shared";
import { inventoryStore } from "../items/inventoryStore.js";
import { toggleInventory } from "./inventory.js";
import { toggleSkillPage } from "./skillPage.js";
import { openCraftBook, closeCraft, isCraftOpen } from "./craftMenu.js";
import { injectTheme } from "./theme.js";

const STYLE_ID = "ghostland-hud-style";

const CSS = `
#gl-hud-bar {
  position: fixed; left: 50%; bottom: 18px; transform: translateX(-50%);
  z-index: 25; display: flex; gap: 10px;
}
.gl-hud-btn {
  position: relative; width: 52px; height: 52px;
  display: flex; align-items: center; justify-content: center;
  background: var(--gl-panel); border: 1px solid var(--gl-border); border-radius: 10px;
  color: var(--gl-text); font-family: ui-monospace, "SFMono-Regular", Menlo, monospace;
  font-size: 22px; font-weight: 700; cursor: pointer; user-select: none;
  box-shadow: 0 8px 24px rgba(0,0,0,.6); transition: border-color .1s, background .1s;
}
.gl-hud-btn:hover { border-color: var(--gl-border-focus); background: var(--gl-panel-2); }
.gl-hud-btn .glyph { letter-spacing: 1px; }
#gl-hud-badge {
  position: absolute; top: -6px; right: -6px; min-width: 18px; height: 18px;
  padding: 0 4px; box-sizing: border-box;
  display: none; align-items: center; justify-content: center;
  background: var(--gl-accent); border-radius: 9px;
  font-size: 10px; font-weight: 700; color: var(--gl-accent-fg);
}
#gl-hud-badge.show { display: flex; }
`;

function ensureStyle(): void {
  injectTheme();
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = CSS;
  document.head.appendChild(style);
}

function totalQuantity(slots: InventorySlot[]): number {
  return slots.reduce((sum, s) => sum + s.quantity, 0);
}

let mounted = false;

/** Mount the bottom-center inventory button (idempotent). */
export function mountHudButton(): void {
  if (mounted) return;
  mounted = true;
  ensureStyle();

  const bar = document.createElement("div");
  bar.id = "gl-hud-bar";

  const btn = document.createElement("div");
  btn.id = "gl-hud-inv"; btn.className = "gl-hud-btn";
  btn.title = "Inventory (I)";
  btn.innerHTML = `<span class="glyph">I</span><span id="gl-hud-badge"></span>`;
  btn.addEventListener("click", () => toggleInventory());

  const skillBtn = document.createElement("div");
  skillBtn.id = "gl-hud-skills"; skillBtn.className = "gl-hud-btn";
  skillBtn.title = "Skills (K)";
  skillBtn.innerHTML = `<span class="glyph">K</span>`;
  skillBtn.addEventListener("click", () => toggleSkillPage());

  const craftBtn = document.createElement("div");
  craftBtn.id = "gl-hud-craft"; craftBtn.className = "gl-hud-btn";
  craftBtn.title = "Craft (U)";
  craftBtn.innerHTML = `<span class="glyph">U</span>`;
  craftBtn.addEventListener("click", () => { if (isCraftOpen()) closeCraft(); else openCraftBook(); });

  bar.append(btn, skillBtn, craftBtn);
  document.body.appendChild(bar);

  const badge = btn.querySelector<HTMLSpanElement>("#gl-hud-badge")!;
  inventoryStore.subscribe((slots) => {
    const total = totalQuantity(slots);
    badge.textContent = total > MAX_STACK ? `${MAX_STACK}+` : String(total);
    badge.classList.toggle("show", total > 0);
  });
}
